export default {
    GRAPH: "Граф",
    TABLE: "Таблица",
    MAP: "Карта",
    CONTENT: "Контент"
};
